import React from 'react';
import { Rate } from 'app/seedly-component-library';
import { REVIEW_PAGE_TYPE } from 'app/constants/product';
import Link from 'app/components/misc/Link';
import { convertDateFormat } from 'app/utils/convertDateFormat';
import UserPassport from 'app/components/profile/UserPassport';

const Header = React.memo(props => {
  const { type, review, category } = props;

  const {
    user: userData,
    rating,
    planName,
    createdAt,
    updatedAt,
    product,
    id: reviewId,
  } = review;

  const date = convertDateFormat(createdAt, updatedAt, 'Posted');

  const Info = () => {
    switch (type) {
      case REVIEW_PAGE_TYPE.PROFILE: {
        const productImage = product.logo;
        const reviewUrl = `/reviews/${category}/${product.slug}?rid=${reviewId}`;
        return (
          <Link href={reviewUrl} passHref>
            <a>
              <div className="mb-3">
                <UserPassport
                  profile={{
                    name: `${product.name} by ${userData.name}`,
                    level: userData.level,
                    achievement: userData.achievement,
                    image: productImage,
                  }}
                />
              </div>
            </a>
          </Link>
        );
      }
      default:
      case REVIEW_PAGE_TYPE.PRODUCT: {
        return (
          <div className="mb-3">
            <UserPassport profile={userData} />
          </div>
        );
      }
    }
  };

  return (
    <div>
      <Info />
      <div className="flex flex-col lg:flex-row mb-2 items-start lg:items-center ">
        <div className="flex gap-3 items-center" size="sm">
          <Rate size={14} disabled defaultValue={rating} />
          <p className="text-xs mr-2.5 text-neutral-500">{date}</p>
        </div>
        {planName && (
          <div className="flex ml-0 lg:ml-2.5">
            <p className="mr-4 text-xs">Purchased</p>
            <p className="text-xs text-neutral-500">{planName}</p>
          </div>
        )}
      </div>
    </div>
  );
});

export default Header;
